import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { SelectionPage } from 'app/BCKSPage/SelectionPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsSelectionPage {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const SelectionPageIndex = (props: PropsSelectionPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <SelectionPage />
}

// eslint-disable-next-line react/display-name
SelectionPageIndex.Layout = ({ children }) => children

export default SelectionPageIndex
